import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

export function initLogoSlider() {
    const logoSwiper = document.querySelector('.swiper-logos');

    if (!logoSwiper) {
        return;
    }

    logoSwiper.classList.add('loaded');

    new Swiper(logoSwiper, {
        modules: [Autoplay, EffectFade],
        slidesPerView: 1,
        effect: 'fade',
        centeredSlides: true,
        fadeEffect: { crossFade: true },
        allowTouchMove: false,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        lazy: true,
        preloadImages: false,
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initLogoSlider();
});
